import { render } from "./PerimeterModal.vue?vue&type=template&id=e741032c&scoped=true"
import script from "./PerimeterModal.vue?vue&type=script&lang=js"
export * from "./PerimeterModal.vue?vue&type=script&lang=js"

import "./PerimeterModal.vue?vue&type=style&index=0&id=e741032c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e741032c"]])

export default __exports__